/**
 * @description i18n en
 * @author wangfupeng
 */

export default {
  videoModule: {
    delete: 'Delete',
    uploadVideo: 'Upload video',
    insertVideo: 'Insert video',
    videoSrc: 'Video source',
    videoSrcPlaceHolder: 'Video file url, or third-party <iframe>',
    videoPoster: 'Video poster',
    videoPosterPlaceHolder: 'Poster image url',
    ok: 'Ok',
    editSize: 'Edit size',
    width: 'Width',
    height: 'Height',
  },
}
